const TabsControls = (($) => {
  class Tabs {
    constructor(node) {
      this.node = node;
      this.$node = $(this.node);
      this.$tabs = this.$node.find('[role="tab"]');
      this.$panels = this.$node.find('[role="tabpanel"]');
      // Followers live in the same widget; widen the selector if you need global control:
      this.$followers = this.$node.find('[data-tab-controlled]');
    }

    init() {
      this.bindEvents();
      // Initialize state from the tab that is aria-selected="true"
      const $initial = this.$tabs.filter('[aria-selected="true"]').first();
      if ($initial.length) {
        this.activateTab($initial);
      }
    }

    bindEvents() {
      // Prevent default button behavior just in case; also support inner SVG clicks.
      this.$tabs.on('click', (event) => {
        event.preventDefault();
        const $tab = $(event.target).closest('[role="tab"]');
        if ($tab.length) this.activateTab($tab);
      });
      this.$tabs.on('keydown', (event) => this.navigateTabs(event));
    }

    activateTab($selectedTab) {
      const selectedPanelId = $selectedTab.attr('aria-controls');
      const $selectedPanel = this.$node.find(`#${selectedPanelId}`);

      // Tabs
      this.$tabs.attr({'aria-selected': 'false', 'tabindex': '-1'});
      $selectedTab.attr({'aria-selected': 'true', 'tabindex': '0'});

      // Panels
      this.$panels.attr('aria-hidden', 'true');
      $selectedPanel.attr('aria-hidden', 'false');

      // Followers: show only those matching the active panel id
      if (this.$followers.length) {
        this.$followers.each((_, el) => {
          const $el = $(el);
          const controls = $el.data('tabControlled'); // jQuery parses data-*
          const isMatch = controls === selectedPanelId;
          $el.toggleClass('hidden', !isMatch);
          // If you want true invisibility for screen readers too, uncomment next line:
          $el.attr('aria-hidden', String(!isMatch));
        });
      }
    }

    changeTab(event) {
      // Kept for backward compatibility; delegate to activateTab
      const $tab = $(event.target).closest('[role="tab"]');
      if ($tab.length) this.activateTab($tab);
    }

    navigateTabs(event) {
      const key = event.key;
      const $currentTab = $(event.target).closest('[role="tab"]');
      let $newTab;

      if (key === 'ArrowRight' || key === 'ArrowDown') {
        $newTab = $currentTab.next('[role="tab"]');
        if (!$newTab.length) $newTab = this.$tabs.first();
      } else if (key === 'ArrowLeft' || key === 'ArrowUp') {
        $newTab = $currentTab.prev('[role="tab"]');
        if (!$newTab.length) $newTab = this.$tabs.last();
      }

      if ($newTab && $newTab.length) {
        $newTab.focus();
        this.activateTab($newTab);
      }
    }
  }

  return {
    init({ selector } = {}) {
      $(selector).each((index, parent) => {
        const module = new Tabs(parent);
        module.init();
      });
    },
  };
})(window.jQuery);

// DOM Ready
(($) => {
  $(document).ready(() => {
    TabsControls.init({
      selector: '[role="tablist"]',
    });
  });
})(window.jQuery);
